<template>
  <div class="ExpandingTable">
    <h4
      class="ExpandingTable__Title"
      @click="showCollapse = !showCollapse"
      :class="titleStyle"
    >
      {{ $t(`FAQ.${index}.title`) }}
      <i :class="iconStyle"></i>
    </h4>
    <div class="ExpandingTable__Text" :class="textStyle">
      <p v-html="this.$t(`FAQ.${index}.text`)"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: { type: Number },
    allExpanded: { type: Boolean, default: false },
  },
  data() {
    return {
      showCollapse: false,
    };
  },
  computed: {
    titleStyle() {
      return this.showCollapse ? "ExpandingTable__Title--Expanded" : null;
    },
    iconStyle() {
      return [
        "fa",
        "fa-angle-down",
        "ExpandingTable__Arrow",
        this.showCollapse ? "ExpandingTable__Arrow--Flipped" : null,
      ];
    },
    textStyle() {
      return this.showCollapse ? null : "ExpandingTable__Text--Hidden";
    },
  },
  watch: {
    allExpanded(val) {
      this.showCollapse = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/mixins";
@import "~@/scss/variables";

.ExpandingTable {
  display: inline-block;
  position: relative;
  text-align: left;
  margin-bottom: 10px;
}

.ExpandingTable__Title {
  cursor: pointer;

  &--Expanded,
  &:hover {
    text-decoration: underline;
    text-decoration-color: $color-primary;
  }

  &:hover .ExpandingTable__Arrow {
    color: $color-primary;
  }
}

.ExpandingTable__Text {
  font-size: 16px;
  margin-bottom: -15px;
  margin-top: -10px;

  &--Hidden {
    display: none;
  }
}

.ExpandingTable__Arrow {
  margin-left: 2px;
  transition: transform 0.2s;

  &--Flipped {
    transform: rotate(180deg);
  }
}
</style>
